// Die API-URL wird über REACT_APP_API_URL aus der Umgebung gesetzt
// In render.yaml: https://${RENDER_EXTERNAL_HOSTNAME}/api
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// API Endpoints
export const API_ENDPOINTS = {
    DASHBOARD: '/dashboard/',
    LOANS: '/loans/',
    // ... weitere Endpoints
};


// Debug-Information
if (process.env.NODE_ENV !== 'production') {
    console.log('Current API URL:', API_BASE_URL);
    console.log('Current Environment:', process.env.NODE_ENV);
}
else {
    console.log('Current API URL:', process.env.REACT_APP_API_URL);
}

export { API_BASE_URL };